import { Component } from "react"

/* Widgets */
import { Authorization, Layout } from "./widgets"

/* JWT */
import { isExpired } from "react-jwt"

/* REST API */
import { refresh as refreshToken } from "./api/Authorization"

/* Components */
import { Toast, Confirm } from "./components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Cookie */
import Cookies from "js-cookie"

/* Modal */
import Modal from "react-modal"

/* DEFAULT CONFIG */
Modal.setAppElement("#root")

/* Entry point */
class App extends Component {

    constructor() {
        super()

        const token = localStorage.getItem("token")
        this.state = {
            token,
            loading: false,
        }
    }

    componentDidMount = () => {

        /* Fields */
        const { token } = this.state
        const refresh = Cookies.get("refresh")

        /* Check Refresh */
        if (!refresh || isExpired(refresh)) {
            this.setState({ token: null })
            localStorage.removeItem("token")
            Cookies.remove("refresh")
            return
        }

        /* Check Token */
        if (!token || isExpired(token)) {

            /* Start Loading */
            this.setState({ loading: true })

            refreshToken({ refresh }).then((response) => {
                if (response.status === 200) {
                    this.setState({ token: response.data.accessToken })
                    localStorage.setItem("token", response.data.accessToken)
                    Cookies.set("refresh", response.data.refreshToken, { expires: 1 })
                }
                else {
                    this.setState({ token: null })
                    localStorage.removeItem("token")
                    Cookies.remove("refresh")
                }
            }).catch(() => {

                this.setState({ token: null })
                localStorage.removeItem("token")
                Cookies.remove("refresh")

            }).finally(() => {
                this.setState({ loading: false })
            })

        }

    }

    /* Draw Content */
    _content = () => {

        const { token, loading } = this.state

        if (loading) {
            return (
                <div className="loading">
                    <LoadingOutlined />
                </div>
            )
        }

        if (!token || isExpired(token)) {
            return <Authorization setToken={(token) => this.setState({ token })} />
        }

        return <Layout token={token} setToken={(token) => this.setState({ token })} />
    }

    render = () => {

        return (
            <>
                {this._content()}

                {/* Toasts and confirmations are mounted once for the whole panel */}
                <Toast />
                <Confirm />
            </>
        )
    }

}

export default App